import {useEffect, useRef, useState} from "react";
import {ArraysAreEqual} from "../../../Constants/DataHelpers";

const useComboBox = (comboData: any, itemKey: string, itemKeyLabel: string, itemKeyType?: string, excluded: any = []) => {
    const [ allSelected, setAllSelected ] = useState<boolean>(false);
    const [ allIndeterminate, setAllIndeterminate ] = useState<boolean>(false);
    const [ selectedIds, setSelectedIds ] = useState<Array<any>>(excluded);

    const selectedIdsRef = useRef<Array<any>>(excluded);

    const data = useRef<any>(comboData);

    const ResetSelection = () => {
        selectedIdsRef.current = [];

        setSelectedIds([]);
        setAllSelected(false);
        setAllIndeterminate(false);
    }

    const ReProcessSelected = () => {
        if(selectedIds.length > 0) {
            selectedIds.forEach((id) => ToggleSingle(id, true))
        }
    }

    const ToggleSingle = (selectedId: any, checked: boolean, singleOnly?: boolean) => {
        if(!data.current || !selectedId) return;

        let convertedId: any;

        if(itemKeyType === 'number') {
            convertedId = parseInt(selectedId);
        } else {
            convertedId = selectedId.toString();
        }

        let selectedItem: any;
        let dataLength: number = 0;

        if(data.current?.pages) {
            data.current.pages.forEach((item: any) => item.data.forEach(() => dataLength = dataLength + 1));
            selectedItem = data.current.pages.map((item: any) => item.data.filter((filterItem : any) => filterItem[itemKey] === convertedId)[0]).filter((finalItem: any) => finalItem)[0];
        } else if (data.current?.data) {
            data.current.data.forEach(() => dataLength = dataLength + 1);
            selectedItem = data.current.data.filter((filterItem : any) => filterItem[itemKey] === convertedId)[0].filter((finalItem: any) => finalItem)[0];
        } else {
            data.current?.forEach(() => dataLength = dataLength + 1);
            selectedItem = data.current.filter((filterItem : any) => filterItem[itemKey] === convertedId)[0];
        }

        if(!selectedItem) return;

        let newSelectedIds = singleOnly ? [] : [...selectedIds];

        const itemSelected = newSelectedIds.indexOf(convertedId);

        if (!checked) {
            newSelectedIds.splice(itemSelected, 1);
        } else if(itemSelected === -1) {
            newSelectedIds.push(selectedItem[itemKey]);
        }

        selectedIdsRef.current = newSelectedIds;

        setAllSelected(dataLength === newSelectedIds.length);
        setAllIndeterminate(newSelectedIds.length > 0 && dataLength !== newSelectedIds.length);
        setSelectedIds(newSelectedIds);

        return newSelectedIds;
    };

    const ToggleAll = (checked: boolean) => {
        if(!data.current) return;

        let tmpSelected : Array<string> = [];
        let tmpSelectedItems : Array<any> = [];

        if(checked) {
            if(data.current?.pages) {
                data.current.pages.map((group: any) =>
                    group.data.map((item: any) => [tmpSelectedItems.push(item), tmpSelected.push(item[itemKey])] )
                )
            } else if (data.current?.data) {
                data.current.data.map((item: any) => [tmpSelectedItems.push(item), tmpSelected.push(item[itemKey])] )
            } else {
                data.current?.map((item : any) => [tmpSelectedItems.push(item), tmpSelected.push(item[itemKey])] )
            }
        }

        selectedIdsRef.current = tmpSelected;

        setAllSelected(checked);
        setAllIndeterminate(false);
        setSelectedIds(tmpSelected);

        return tmpSelected;
    };

    const SetSelection = (values: Array<any>) => {
        if(!data.current) return;

        let dataLength: number = 0;

        let newFilteredItems: any;

        if(data.current?.pages) {
            data.current.pages.forEach((item: any) => item.data.forEach(() => dataLength = dataLength + 1));
            newFilteredItems = data.current.pages.map((item: any) => item.data.filter((filterItem : any) => values.includes(filterItem[itemKey])));
        } else if (data.current?.data) {
            data.current.data.forEach(() => dataLength = dataLength + 1);
            newFilteredItems = data.current.data.filter((filterItem : any) => values.includes(filterItem[itemKey]));
        } else {
            data.current?.forEach(() => dataLength = dataLength + 1);
            newFilteredItems = data.current?.filter((filterItem : any) => values.includes(filterItem[itemKey]));
        }

        if(!newFilteredItems) return;

        let newSelectedIds: any = [];

        newFilteredItems.forEach((selectedItem: any) => {
            newSelectedIds.push(selectedItem.value);
        });

        selectedIdsRef.current = newSelectedIds;

        setAllSelected(dataLength === newSelectedIds.length);
        setAllIndeterminate(newSelectedIds.length > 0 && dataLength !== newSelectedIds.length);

        setSelectedIds(newSelectedIds);
    };

    useEffect(() => {
        if(!ArraysAreEqual(selectedIds, excluded)) {
            setSelectedIds(excluded);
            selectedIdsRef.current = excluded;
        }
    }, [excluded]);

    useEffect(() =>{
        data.current = comboData;
    }, [comboData]);

    return { allSelected, allIndeterminate, selectedIds, selectedIdsRef, SetSelection, ReProcessSelected, ResetSelection, ToggleSingle, ToggleAll };
}

export default useComboBox